<app-breadcrumb [title]="'Mi Cuenta'" [breadcrumb]="'Mi Cuenta'"></app-breadcrumb>
<!-- section start -->
<section class="section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-lg-3">
                <div class="account-sidebar" (click)="ToggleDashboard()">
                    <a hre="javascript:void(0)" class="popup-btn">
                        Mi Cuenta                    </a>
                </div>
                <div class="dashboard-left" [class.open]="openDashboard">
                    <div class="collection-mobile-back" (click)="ToggleDashboard()">
                        <span class="filter-back">
                            <i class="fa fa-angle-left" aria-hidden="true"></i> back
                        </span>
                    </div>
                    <div class="block-content">
                        <ul>
                            <li class="active"><a href="javascript:void(0)">Información de la Cuenta</a></li>
                            <li style="cursor: pointer;"><a (click)="irDirecciones()">Mis Direcciones</a></li>
                            <!-- <li style="cursor: pointer;"><a (click)="irDatosFacturacion()">Datos Facturación</a></li> -->
                            <li style="cursor: pointer;"><a (click)="irMisPedidos()">Mis Pedidos</a></li>
                            <li style="cursor: pointer;"><a (click)="irWishList()">Lista de Deseos</a></li>
                            <!-- <li style="cursor: pointer;"><a (click)="metodosPago()">Métodos de pago</a></li> -->
                            <li style="cursor: pointer;"><a (click)="irPerfil()">Mi Cuenta</a></li>
                            <li style="cursor: pointer;"><a (click)="irCambiarContrasena()">Cambiar Contraseña</a></li>
                            <li class="last"><a (click)="logout()">Cerrar Sesión</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-9">
                <div class="dashboard-right">
                    <div class="dashboard">
                        <div class="box-head">
                            <h2>Mi Tablero</h2>
                        </div>
                        <div class="welcome-msg">
                            <p>Hola, {{this.usuario.nombreCompleto}}!</p>
                            <p>Desde el panel de control puedes ver una instantánea vista de tu actividad reciente y actualizar la información de tu cuenta. Selecciona un enlace a continuación para ver o editar la información.</p>
                        </div>
                        <div class="box-account box-info">
                            <div class="box-head">
                                <h2>Información de la Cuenta</h2>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="box">
                                        <div class="box-title">
                                            <h3>Mi Cuenta</h3>
                                            <a style="cursor: pointer;" (click)="irPerfil()">Editar</a>
                                        </div>
                                        <div class="box-content">
                                            <h6><a (click)="irCambiarContrasena()">Cambiar Contraseña</a></h6>
                                        </div>
                                    </div>
                                </div>
                                <!--<div class="col-sm-6">
                                    <div class="box">
                                        <div class="box-title">
                                            <h3>Newsletters</h3>
                                            <a  >Edit</a>
                                        </div>
                                        <div class="box-content">
                                            <p>
                                                You are currently not subscribed to any newsletter.
                                            </p>
                                        </div>
                                    </div>
                                </div>-->
                            </div>
                            <div>
                                <div class="box">
                                    <div class="box-title">
                                        <h3>Direcciones</h3>
                                        <a style="cursor: pointer;" (click)="irDirecciones()">Administrar Direcciones</a>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <h6>Dirección de entrega por defecto</h6>
                                            <address *ngIf="showInfovacio">
                                                Sin direcciones registradas
                                                <a style="cursor: pointer;" (click)="agregarDireccion()">Agregar dirección</a>
                                            </address>
                                            <div *ngIf="this.direccion != null" style="display: inline-flex;">
                                                <!-- {{direccion.calle}}, {{direccion.noInterior}} {{direccion.noExterior}} {{direccion.colonia}} {{direccion.municipio}} {{direccion.estado}} {{direccion.codigoPostal}} {{direccion.calleEsquina}} -->
                                                <ng-container *ngIf="direccion.estado != null && direccion.estado != '' ">{{direccion.estado}}, </ng-container>
                                                <ng-container *ngIf="direccion.estado == null || direccion.estado == '' ">Sin datos, </ng-container>

                                                <ng-container *ngIf="direccion.municipio != null && direccion.municipio != '' ">{{direccion.municipio}}, </ng-container>
                                                <ng-container *ngIf="direccion.municipio == null || direccion.municipio == '' ">Sin datos, </ng-container> 

                                                <ng-container *ngIf="direccion.colonia != null && direccion.colonia != '' ">{{direccion.colonia}}, </ng-container>
                                                <ng-container *ngIf="direccion.colonia == null || direccion.colonia == '' ">Sin datos, </ng-container>

                                                <ng-container *ngIf="direccion.calle != null && direccion.calle != '' ">{{direccion.calle}}, </ng-container>
                                                <ng-container *ngIf="direccion.calle == null || direccion.calle == '' ">Sin datos, </ng-container>

                                                <ng-container *ngIf="direccion.calleEsquina != null && direccion.calleEsquina != '' ">{{direccion.calleEsquina}}, </ng-container>
                                                <ng-container *ngIf="direccion.calleEsquina == null || direccion.calleEsquina == '' ">Sin datos </ng-container>

                                                <ng-container *ngIf="direccion.noInterior != null && direccion.noInterior != '' ">{{direccion.noInterior}}/</ng-container>
                                                <ng-container *ngIf="direccion.noInterior == null || direccion.noInterior == '' ">Sin datos, </ng-container> 

                                                <ng-container *ngIf="direccion.noExterior != null && direccion.noExterior != '' ">{{direccion.noExterior}}, </ng-container>
                                                <ng-container *ngIf="direccion.noExterior == null || direccion.noExterior == '' ">Sin datos, </ng-container> 

                                                <ng-container *ngIf="direccion.codigoPostal != null && direccion.codigoPostal != '' ">C.P. {{' ' + direccion.codigoPostal}} </ng-container>
                                                <ng-container *ngIf="direccion.codigoPostal == null || direccion.codigoPostal == '' ">Sin datos </ng-container>
                                            </div>
                                            <a style="cursor: pointer;" *ngIf="this.direccion != null" [routerLink]="['/pages/editar-direccion', direccion.id]">Editar dirección</a>
                                        </div>
                                        <!-- <div class="col-sm-6">
                                            <h6>Dirección de facturación por defecto</h6>
                                            <address>
                                                No se ha establedico una dirección de facturación predeterminada.<br>
                                                <a style="cursor: pointer;" (click)="irDirecciones()">Editar dirección</a>
                                            </address>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- section end -->